<template>
  <div class="product-choice-summary">
    <div>
      <span class="specific text-muted" v-for="attr in product.stockAttributes" :class="`-${attr.key}`">
        <span class="label">{{ attr.key }}: <span class="selected">{{ choices[attr.key] || '-' }}</span></span>
      </span>
    </div>

    <transition name="fade" v-if="lowQuantity">
      <div class="mt-15 text-muted" :class="{ '-error --error': !stockAvailable }">
        จำนวนคงเหลือ:
        <em v-if="!stockChecking"><span v-if="stockQuantity > 0">ประมาณ </span>{{ stockQuantity | comma }} รายการ</em>
        <em v-else>กำลังตรวจสอบ...</em>
        <div class="fl-right" v-if="stockAvailable">✔</div>
        <div class="fl-right" v-else>✗</div>
        <br><button class="text-muted-ss" @click="checkStock()" :disabled="stockChecking">ตรวจสอบอีกครั้ง</button>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ProductChoiceSummary',
  props: {
    product: {
      type: Object,
      required: true
    },
    choices: {
      type: Object,
      required: false
    },
    quantity: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      stockChecking: false,
      stockAvailable: true,
      stockQuantity: 0
    }
  },
  mounted () {
    this.checkStock()
  },
  computed: {
    lowQuantity () {
      return this.stockQuantity < 50
    }
  },
  methods: {
    checkStock () {
      this.stockChecking = true

      let configSku = this.$utils.getProductConfigSku(this.product, this.choices)
      this.$http.get(`inventories/check/${configSku}`)
        .then(resp => {
          setTimeout(() => {
            this.stockChecking = false
          }, 500)
          if (resp.body.item) {
            this.stockQuantity = resp.body.item.quantity || 0
          } else {
            this.stockQuantity = 0
          }
          this.stockAvailable = this.stockQuantity >= this.quantity
        })
        .catch(err => {
          console.log(err)
          setTimeout(() => {
            this.stockChecking = false
          }, 500)
          this.stockAvailable = false
        })
    }
  },
  watch: {
    quantity: function () {
      this.stockAvailable = this.stockQuantity >= this.quantity
    }
  }
}
</script>

<style scoped lang="scss">
@import 'theme';

.label {
  &:after {
    content: ' / '
  }
}

.specific:last-child {
  .label {
    &:after {
      content: ''
    }
  }
}

.selected {
  color: #000;
  padding: 0 3px;
  background: #fff;
  border: 1px solid #C993C1;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// ProductChoiceSummary.vue?ef186b4a